import { discountApi, GlobalZipUpdate, zipCodeError } from "..";
import { const_var, params } from "../../redux/reducers/reducer";
import { decodeKey, loadStripe } from "../../redux/reducers/utils";
import { getManufactureList, getManufactureMetaData } from "../../services/manufacture.services";

const initLoaderState = (zipCode) => {
	const_var.is_loader = true;
	const_var.zipManufErrMsg = "";
	const_var.isZipcodeIncluded = true;
	if (const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true && const_var.showStateField == false && const_var.showStateOnly == false) {
		const_var.showReportLoading = true;
	}
	if (zipCode == undefined) {
		zipCode = "";
	}
};
const GUEST_DOMAIN = "cibirix.com";
const WALL_COLOR_MAP = {
	GuEssZt4YAZi5ot69xbO9I4w3dbxgPJNXsUFCJJPevH3zt1ONTUabif5hRKJ41Oc: "red",
	Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG: "#e1a901"
};

const getUserData = () => {
	const raw = localStorage.getItem("userData");
	return raw ? JSON.parse(raw) : null;
};

const setWallColor = (apiToken) => {
	if (WALL_COLOR_MAP[apiToken]) {
		const_var.wallNameColor = WALL_COLOR_MAP[apiToken];
	}
};

const buildBaseStateApiData = (userData) => {
	if (userData) {
		const_var.crmSetting.login_user_id = userData.user_id;
		const_var.is_loggedinUserData.id = userData.user_id;
		const_var.loginSession = true;
		return {
			user_id: userData.user_id,
			api_token: const_var.crmSetting.api_token
		};
	}
	if (!const_var.loginSession) {
		return {
			user_id: null,
			api_token: const_var.crmSetting.api_token,
			estimator_domain: const_var.crmSetting.main_domain_url || GUEST_DOMAIN
		};
	}
	return {
		user_id: const_var.is_loggedinUserData?.id ?? 2,
		api_token: const_var.crmSetting.api_token
	};
};

const resolveZipCode = (zipCode) => {
	const { is_zipcode_screen, is_Edit } = const_var.crmSetting;
	if (!is_zipcode_screen) return null;
	if (zipCode && !is_Edit) return zipCode;
	if (!const_var.isFromCompare && const_var.state_mfg_zipcode) {
		return const_var.state_mfg_zipcode;
	}
	if (const_var.isFromCompare && const_var.state_mfg_zipcode_old && const_var.showStateBoxInZipDefault) {
		return const_var.state_mfg_zipcode_old;
	}
	return null;
};

const handleUserCompanies = (userData, StateApiData) => {
	const userCompanies = userData?.user_companies;
	if (userCompanies?.length) {
		const_var.userCompanies = userCompanies;
		const_var.isFromSalesLogin = true;
	}
	/*  For Create case */
	if (const_var.isFromSalesLogin == true && const_var.loginSession == true && userCompanies?.length && !const_var.crmSetting.is_Edit) {
		const defaultCompany = userCompanies.find((c) => c?.is_selected) || userCompanies[0];
		if (!params.company_id) {
			params.company_id = defaultCompany?.company_id;
			const_var.companyIdSelectedFromStateScreen = params.company_id;
		}
		StateApiData = {
			...StateApiData,
			company_id: params.company_id
		};
	}
	return StateApiData;
};
const handleStripeCheckout = (responseData, const_var) => {
	const { checkout_key, checkout_type } = responseData;
	if (checkout_key && checkout_type === "stripe") {
		const_var.stripe["checkout_key"] = checkout_key;
		const_var.stripe["checkout_type"] = checkout_type;
		decodeKey(checkout_key, const_var).then((val) => {
			const_var.paymentOption.key = val;
			loadStripe(val);
		});
	}
};
const handleCompany = ({ response, dispatch, zipCode }) => {
	if (!response?.data?.status) return;
	const responseData = response.data;
	const_var.crmSetting.companyType = responseData.company_type;
	const_var.crmSetting.discount_api_url = responseData.discount_api_url;
	const_var.crmSetting.company_mnf_id = responseData.company_manufacturer_id;
	const_var.isLTEnable = responseData.is_l_and_t && responseData.is_l_and_t == 1 ? true : false;
	const_var.isStorageMovementEnable = responseData.is_storage_movement && responseData.is_storage_movement == 1 ? true : false;
	if (const_var.loginSession == false) {
		const_var.crmSetting.is_hide_discount = responseData.is_hide_discount == 1 ? false : true;
	} else {
		const_var.crmSetting.is_hide_discount = true;
	}
	const_var.displayerrorMessage.company_id = "";
	const_var.stateManufactureDataFromApi = structuredClone(responseData.data);
	const_var.crmSetting.companyType = responseData.company_type;
	const_var.crmSetting.discount_api_url = responseData.discount_api_url;
	const_var.crmSetting.company_mnf_id = responseData.company_manufacturer_id;
	if (const_var.loginSession == false) {
		const_var.crmSetting.is_hide_discount = responseData.is_hide_discount == 1 ? false : true;
	} else {
		const_var.crmSetting.is_hide_discount = true;
	}
	if (
		const_var.crmSetting.pre_quote_form != undefined &&
		const_var.crmSetting.pre_quote_form == true &&
		responseData.status == false &&
		const_var.loginSession == false &&
		localStorage.getItem("userData") == undefined
	) {
		const_var.SApiCalled = true;
		const_var.showStateField = true;
		dispatch(zipCodeError(responseData.message));
		if (zipCode != undefined && zipCode != "") {
			const_var.shippingState = "";
		}
	}
};
function handleInsideZipTool({ insideZipTool, response, dispatch }) {
	if (insideZipTool == undefined || insideZipTool != true) return;
	const responseData = response?.data;
	dispatch(GlobalZipUpdate(undefined));
	const_var.zipcodeToolTipData = responseData;
	const_var.is_loader = false;
	const_var.showProcessLoaderchkEdit = false;
	const_var.showStateBoxInZipErr = responseData?.status;
	if (const_var.crmSetting?.is_zipcode_screen == true) {
		if (responseData.status == false && const_var.loginSession == false && localStorage.getItem("userData") == undefined) {
			const_var.SApiCalled = true;
			dispatch(zipCodeError(responseData.message));
			const_var.is_loader = false;
			return;
		}
		if (responseData.status == false && const_var.loginSession == true && (const_var.crmSetting.is_loggedin == true || localStorage.getItem("userData") != undefined)) {
			const_var.showStateZip = true;
			dispatch(zipCodeError(responseData.message));
			dispatch(GlobalZipUpdate(undefined));

			const_var.zipcodeToolTipData = responseData;
		}
		if (responseData.status == true && responseData.message != undefined && responseData.message != "") {
			const_var.zipManufErrMsg = responseData.message;
		}
	}
}
const createManufacturer = (withComparison = false, manufactureId, manufactureName) => ({
	building_type: [],
	commissions: [],
	discounts: [],
	document_fee: 0,
	id: manufactureId,
	is_document_show_in_3d: 0,
	is_labor_show_in_3d: 0,
	is_permit_show_in_3d: 0,
	is_processing_show_in_3d: 0,
	labor_fee: 0,
	manufacture_discount: [],
	name: manufactureName,
	order_permit_fee: 0,
	order_processing_fee: 0,
	roof_color: null,
	surcharge: [],
	trim_color: null,
	wall_color: null,
	...(withComparison && { price_comparision: [] })
});
const updateDiscount = () => {
	const rate = const_var.editAPIDataByResponse.data.request_data?.building?.discount_rate;
	const_var.UpdatedPriceData.discount_rate_updated = true;
	const_var.UpdatedPriceData.discount_rate = parseFloat(rate);
};
const resetManufacturerDiscount = () => {
	const buildingData = const_var.editAPIDataByResponse.data.request_data?.building;
	if (buildingData?.discount_rate_updated) {
		buildingData.manufacturer_discount_label = "";
		buildingData.manufacturer_discount_changed = false;
		buildingData.discount_rate = 0;
		buildingData.discount_type = "per";
		buildingData.discount_amount = 0;
		buildingData.discount_rate_updated = undefined;
	}
};
const createManufacturerAndUpdateDiscount = (chkDataExistOrNot, response) => {
	if (!const_var.editAPIDataByResponse.data.all_state_and_manufacturers) {
		if (chkDataExistOrNot.length > 0) {
			if (chkDataExistOrNot[0].manufacturer_list.length > 1) {
				if (const_var.isFromPickThis == true && const_var.removedManufacturer != undefined) {
					let chkManufacturerExistOrNot = chkDataExistOrNot[0].manufacturer_list.filter((data) => data.id == const_var.removedManufacturer.id);
					if (chkManufacturerExistOrNot.length == 0) {
						chkDataExistOrNot[0].manufacturer_list.push(createManufacturer(false, const_var.removedManufacturer.id, const_var.removedManufacturer.name));
						updateDiscount();
					}
				}
				if (const_var.isFromPickThis != true) {
					let chkManufacturerExistOrNot = chkDataExistOrNot[0].manufacturer_list.filter((data) => data.id == params.m_s_n);
					if (chkManufacturerExistOrNot.length == 0) {
						chkDataExistOrNot[0].manufacturer_list.push(
							createManufacturer(false, const_var.editAPIDataByResponse.data.request_data.building.manufacturer, const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name)
						);
						const_var.removedManufacturer = {
							id: const_var.editAPIDataByResponse.data.request_data.building.manufacturer,
							name: const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name
						};
						updateDiscount();
					}
				}
			} else {
				if (chkDataExistOrNot[0].manufacturer_list.some((item) => item.id == params.m_s_n)) {
					if (Array.isArray(chkDataExistOrNot[0]?.manufacturer_list) && chkDataExistOrNot[0].manufacturer_list?.length > 0) {
						chkDataExistOrNot[0].manufacturer_list.push(
							createManufacturer(false, const_var.editAPIDataByResponse.data.request_data.building.manufacturer, const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name)
						);
						updateDiscount();
					}
				}
			}
		} else {
			/* Handling case when State is removed */
			let stateName = const_var.editAPIDataByResponse.data.states[const_var.editAPIDataByResponse.data.request_data.building.state - 1];
			response.data.data.push({
				id: const_var.editAPIDataByResponse.data.request_data.building.state,
				manufacturer_list: [],
				state_name: stateName != undefined ? stateName.name : "test"
			});
			response.data.data[response.data.data.length - 1].manufacturer_list = [];
			response.data.data[response.data.data.length - 1].manufacturer_list.push(
				createManufacturer(false, const_var.editAPIDataByResponse.data.request_data.building.manufacturer, const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name)
			);
			updateDiscount();
		}
	} else {
		// -------- KLink Flow --------
		if (const_var.isKLinkEnable == true || (const_var.isPublicEdit == true && const_var.loginSession == false)) {
			if (chkDataExistOrNot.length > 0) {
				if (chkDataExistOrNot[0].manufacturer_list.length > 1) {
					let chkManufacturerExistOrNot = chkDataExistOrNot[0].manufacturer_list.filter((data) => data.id == params.m_s_n);
					if (chkManufacturerExistOrNot.length == 0) {
						chkDataExistOrNot[0].manufacturer_list.push(
							createManufacturer(true, const_var.editAPIDataByResponse.data.request_data.building.manufacturer, const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name)
						);
						const_var.removedManufacturer = {
							id: const_var.editAPIDataByResponse.data.request_data.building.manufacturer,
							name: const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name
						};
						updateDiscount();
					} else {
						if (const_var.editAPIDataByResponse.data.request_data?.building?.discount_rate_updated) {
							resetManufacturerDiscount(const_var.editAPIDataByResponse.data.request_data?.building);
						}
					}
				} else {
					let manuExistInAllStateDataIndex = const_var.editAPIDataByResponse.data.all_state_and_manufacturers[0]?.manufacturer_list.findIndex((item) => item.id == params.m_s_n);
					if (manuExistInAllStateDataIndex == -1) {
						if (chkDataExistOrNot[0].manufacturer_list[0].id != params.m_s_n) {
							response.data.data[response.data.data.length - 1].manufacturer_list = createManufacturer(
								true,
								const_var.editAPIDataByResponse.data.request_data.building.manufacturer,
								const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name
							);
							updateDiscount();
						}
					} else {
						resetManufacturerDiscount(const_var.editAPIDataByResponse.data.request_data?.building);
					}
				}
			}
		} else {
			const states = const_var.isKLinkEnable ? const_var.editAPIDataByResponse.data.all_states : const_var.editAPIDataByResponse.data.states;
			const stateName = states.find(({ id }) => id == const_var.editAPIDataByResponse.data.request_data.building.state);
			response.data.data.push({
				id: const_var.editAPIDataByResponse.data.request_data.building.state,
				manufacturer_list: {},
				state_name: stateName?.name ?? "test"
			});
			response.data.data[response.data.data.length - 1].manufacturer_list = createManufacturer(
				true,
				const_var.editAPIDataByResponse.data.request_data.building.manufacturer,
				const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name
			);
			updateDiscount();
		}
	}
};

export const getDealerStateList = (isZipEnable = false, isApiCall = true, zipCode, insideZipTool) => {
	initLoaderState(zipCode);
	return async (dispatch) => {
		if (const_var.crmSetting?.pre_quote_form == true && !const_var.loginSession && !const_var.showStateField && !const_var.showStateOnly) {
			dispatch(zipCodeError(""));
		}
		if (isZipEnable == true) {
			if (const_var.crmSetting?.is_zipcode_screen == true && const_var.showStateField == false && const_var.showStateOnly == false) {
				const_var.showReportLoading = false;
			}
			const_var.showProcessLoaderchkEdit = false;
		} else {
			const newData = getUserData();
			let StateApiData = buildBaseStateApiData(newData);
			setWallColor(const_var.crmSetting.api_token);
			const resolvedZip = resolveZipCode(zipCode);
			if (resolvedZip) {
				StateApiData.zipcode = resolvedZip;
			}
			StateApiData = { ...StateApiData, ...handleUserCompanies(newData, StateApiData) };

			/* For klink & public url case */
			if (const_var.crmSetting.is_Edit && (const_var.isKLinkEnable || const_var.isPublicEdit)) {
				const editData = const_var.editAPIDataByResponse?.data;
				params.company_id = editData?.company_id ?? editData?.request_data?.company_id;
			}
			const currentUrl = window.location.href;
			const requestData = const_var.editAPIDataByResponse?.data?.request_data;
			const hasSenseiSalesId = requestData?.sensei_sales_id !== undefined;
			const hasCompanyId = requestData?.company_id !== undefined;
			if (currentUrl?.includes("3d-public") && (hasSenseiSalesId || hasCompanyId)) {
				StateApiData.api_token = const_var.requestApiToken;
			}
			// ---------- Zipcode Screen State Handling ----------
			const { is_zipcode_screen } = const_var.crmSetting;
			if (is_zipcode_screen && !isApiCall) {
				if (!const_var.showStateField && !const_var.showStateOnly) {
					const_var.showReportLoading = false;
				}
				dispatch({
					type: "SELECTED_TAB_STATE",
					key: "statechange"
				});
			} else {
				const promises = [getManufactureList(const_var.crmSetting.api_token, zipCode), getManufactureMetaData(const_var.crmSetting.api_token)];
				return Promise.all(promises)
					.then(([manufactureList, manufactureMetaData]) => {
						const response = { data: { status: false } };
						const_var.showReportLoading = false;
						response.data.data = manufactureList.data;
						manufactureMetaData.data.discount_api_url = "https://pre-gateway.senseicrm.com/";
						if (manufactureMetaData?.data?.two_d_layout) {
							manufactureMetaData.data.two_d_layuot = manufactureMetaData.data.two_d_layout;
						}
						Object.assign(response.data, manufactureMetaData.data);
						response.data.status = true;
						handleStripeCheckout(response.data, const_var);
						if (response.data && response.data?.discount_api_url) {
							const_var.crmSetting.discount_api_url = response.data.discount_api_url;
						}
						handleCompany({ response, dispatch, zipCode });
						if (insideZipTool != undefined && insideZipTool == true) {
							handleInsideZipTool({ insideZipTool, response, dispatch });
						} else {
							if (response.data) {
								if (const_var.isFromCompare && const_var.crmSetting.is_zipcode_screen && !const_var.showStateBoxInZipDefault) {
									const_var.showStateBoxInZipErr = false;
								} else if (const_var.crmSetting.is_zipcode_screen && !const_var.editAPIDataByResponse?.data?.request_data?.building?.state_mfg_zipcode) {
									const_var.showStateBoxInZipErr = !(const_var.isFromCompare && response?.data?.status && StateApiData?.zipcode === undefined && !const_var.zipCode) && response?.data?.status;
								} else {
									const_var.showStateBoxInZipErr = response?.data?.status;
								}
								if (response?.data?.hide_price_calculation === 1) {
									const_var.hideCompareOption = true;
								}
								if (
									const_var.crmSetting.is_Edit === true &&
									!const_var.isKLinkEnable &&
									!const_var.isFromCompare &&
									!Array.isArray(response?.data?.data?.[0]?.manufacturer_list) &&
									response?.data?.data?.[0]?.manufacturer_list?.price_comparision?.length === 0
								) {
									const_var.hideCompareOption = true;
								}
								if (!const_var.isFromCompare && const_var.crmSetting.is_zipcode_screen) {
									const_var.state_mfg_zipcode_old = const_var.state_mfg_zipcode;
								}
								const_var.showStateFieldInToolTip = response?.data?.data?.length !== 1;
								const_var.zipErrorMsgFlag = response?.data?.is_zipcode_included !== false;
							}
							if (const_var.crmSetting?.is_zipcode_screen == true) {
								if (response.data.status == false && const_var.loginSession == false && localStorage.getItem("userData") == undefined) {
									const_var.SApiCalled = true;
									dispatch(zipCodeError(response.data.message));
									const_var.is_loader = false;
									return;
								}
								if (response.data.status == false && const_var.loginSession == true && (const_var.crmSetting.is_loggedin == true || localStorage.getItem("userData") != undefined)) {
									const_var.showStateZip = true;
									dispatch(zipCodeError(response.data.message));
								}
								if (response.data.status == true && response.data.message != undefined && response.data.message != "") {
									const_var.zipManufErrMsg = response.data.message;
								}
							}
							const_var.MFApiCalled = true;
							const_var.SApiCalled = true;
							if (response.data?.is_maintenance) {
								const_var.IsMentananceWindow = true;
								return;
							}
							if (const_var.crmSetting?.is_zipcode_screen == false && const_var.crmSetting?.pre_quote_form == undefined && response.data.data.length == 1 && const_var.crmSetting.is_Edit == false) {
								const_var.showProcessLoaderchkEdit = true;
							}
							if (const_var.crmSetting.is_Edit == true && response.data.status == true) {
								if (
									const_var.editAPIDataByResponse.data != undefined &&
									const_var.editAPIDataByResponse.data.created_at < "2023-02-20" &&
									const_var.editAPIDataByResponse.data.request_data.building.surcharge_on_discounted_subtotal == undefined
								) {
									let updatedData = "";
									let NewData = response.data.data.filter((newData) => newData.id == params.p_s_n);
									if (NewData.length > 0) {
										updatedData = NewData[0].manufacturer_list.filter((data) => data.id == params.m_s_n)[0];
										if (updatedData != "" && updatedData.surcharge.length > 0) {
											updatedData.surcharge.map((data, key) => {
												updatedData.surcharge[key].surcharge_on_discounted_subtotal = 0;
											});
										}
									}
								}
							}
							if (response.data != undefined) {
								if (response.data.price_edit == 1) {
									const_var.is_price_edit = true;
								} else {
									const_var.is_price_edit = false;
								}
							}
							let chkRecords = response.data.data.filter((data) => {
								return data.manufacturer_list.length;
							});
							let chkDataExistOrNot = response.data.data.filter((data) => data.id == params.p_s_n);
							if (
								const_var.crmSetting.is_Edit == true &&
								const_var.isFromPickThis == false &&
								const_var.editAPIDataByResponse != undefined &&
								Object.keys(const_var.editAPIDataByResponse)?.length > 0 &&
								const_var.editAPIDataByResponse?.data?.request_data != undefined
							) {
								createManufacturerAndUpdateDiscount(chkDataExistOrNot, response);
							}
							const hasManufacturer = response.data.data.some((item) => item.id == params.p_s_n && item.manufacturer_list.some((m) => m.id == params.m_s_n));
							if (chkRecords.length > 0 && const_var.crmSetting.is_Edit && !const_var.isFromCompare && !hasManufacturer) {
								dispatch({
									type: "CheckSharingAlertBox",
									value: "show"
								});
							} else {
								if (Object.keys(const_var.editAPIDataByResponse).length > 0 && const_var.editAPIDataByResponse?.data?.request_data) {
									const apiData = const_var.editAPIDataByResponse.data;
									if (apiData?.all_state_and_manufacturers && Object.keys(apiData.all_state_and_manufacturers).length > 0) {
										const manufacturerSource = apiData.all_state_and_manufacturers?.[0]?.manufacturer_list;
										const data = response.data.data.find((d) => d.id == params.p_s_n);
										if (data) {
											if (data.manufacturer_list.price_comparision != undefined && const_var.loginSession == false) {
												let priceCompData = data.manufacturer_list.price_comparision;
												data.manufacturer_list = manufacturerSource?.filter((data) => data.id == params.m_s_n)[0];
												if (data.manufacturer_list != undefined && data.manufacturer_list?.price_comparision == undefined) {
													data.manufacturer_list["price_comparision"] = priceCompData;
												} else {
													data.manufacturer_list = createManufacturer(
														true,
														const_var.editAPIDataByResponse.data.request_data.building.manufacturer,
														const_var.editAPIDataByResponse.data.request_data.building.manufacturer_name
													);
													updateDiscount();
												}
											} else {
												data.manufacturer_list = manufacturerSource?.filter((d) => d.id == params.m_s_n)?.[0];
											}
										}
									}
								}
								dispatch({
									type: "setDealerStateList",
									value: response.data
								});

								if (const_var.selectedTabKeyForWheel == "loginstyletab") {
									dispatch({
										type: "SELECTED_TAB_STATE",
										key: "statechange"
									});
								}
								if (const_var.crmSetting.is_Edit == true && response.data.status == true) {
									dispatch({
										type: "DEFAULTBUILDINGDATA",
										value: { data: const_var.editAPIDataByResponse.data.building_data, success: true }
									});
									dispatch({
										type: "SELECTED_TAB_STATE",
										key: "buildingtypetab"
									});

									const_var.CallApionAction = true;
									const_var.UpdatedPriceData = const_var.editAPIDataByResponse.data.request_data.building;
									dispatch({
										type: "SETPRICINGDATA",
										value: { data: const_var.editAPIDataByResponse.data.pricing_data, success: true },
										isEdit: true
									});
									const setLeanData = (side, type, action) => {
										const lean = const_var.newLeanArr[side];
										if (lean && lean.leanto_type === type && lean.pricing_data) {
											const_var.UpdatedPriceData.leanto[lean.main_index] = lean;
											dispatch({
												type: "SETPRICINGDATAFORLEANTO",
												value: { data: lean.pricing_data, success: true },
												str: action
											});
										}
									};
									setLeanData("left", 1, "addLeftLean");
									setLeanData("right", 2, "addRightLean");
									setLeanData("front", 3, "addFrontLean");
									setLeanData("back", 4, "addBackLean");
									dispatch({ type: "editActionAfterPreparingData", data: const_var.editAPIDataByResponse.data.building_data, doorData: const_var.isIspiration_doorData });
									dispatch({ type: "loadCupolaInEditMode", data: const_var.editAPIDataByResponse.data.request_data.building });
									dispatch({ type: "UpdateState" });
								}
							}
							if (const_var.crmSetting.pre_quote_form == true && zipCode) {
								const_var.shippingState = const_var.stateNameAcordingAPI[params.p_s_n];
								dispatch({ type: "setPriceCompareForNonLoggedIn", value: "", key: "" });
							}
							if (const_var.isFromCompare != true && params.m_s_n) {
								const apiDiscountData = {
									api_token: const_var.crmSetting.api_token,
									manufacturer_id: "all",
									"3D": true
								};
								if (
									((const_var.crmSetting.is_CRM == undefined || const_var.crmSetting.is_CRM == false) && const_var.loginSession == true) ||
									(const_var.crmSetting.is_Edit == true && const_var.isCompanyChangedInEdit == true) ||
									const_var.isKLinkEnable == true ||
									(const_var.isPublicEdit == true && const_var.crmSetting.is_Edit == true)
								) {
									apiDiscountData.company_id = params.company_id;
								}
								if (!const_var?.is_intel) {
									dispatch(discountApi(apiDiscountData, "all"));
								}
							}
							if (response.data.data.length > 1 && const_var.crmSetting.is_Edit == false) {
								const_var.showProcessLoaderchkEdit = false;
							}

							const_var.is_loader = false;
						}
					})
					.catch((err) => {
						console.log("err", err);
						// const response = error.response;
						const error = { response: { data: { message: "", status: false } } };
						error.response.data.message = err.message;
						if (const_var.crmSetting.is_zipcode_screen) {
							const_var.showReportLoading = false;
						}
						const_var.SApiCalled = true;
						const_var.showStateField = true;
						dispatch(zipCodeError(error.response.data.message));
						let userLoggedIn = localStorage.getItem("userData") ? true : false;
						if (error?.response?.data != undefined && error?.response?.data?.status == false && const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && userLoggedIn == false) {
							dispatch(getDealerStateList());
						}
						if (const_var.crmSetting.pre_quote_form == true && zipCode != undefined && zipCode != "") {
							const_var.shippingState = "";
						}
						if (insideZipTool == true) {
							const_var.displayerrorMessage.company_id = error.response.data.message;
						} else {
							params.p_s_n = "Select";
							const_var.bjD = [];
							const_var.stateManufacturerAcordingAPI = {};
							const_var.stateManufactureDataFromApi = [];
							const_var.confirmState = false;
							const_var.displayerrorMessage.company_id = error.response.data.message;
						}
					});
			}
		}
	};
};

export function stateManufacturerChange(val, key) {
	if (
		const_var.crmSetting.pre_quote_form == true &&
		const_var.post_data.address != undefined &&
		const_var.post_data.address.length > 0 &&
		const_var.shippingState != undefined &&
		const_var.shippingState != "" &&
		const_var.stateNameAcordingAPI[val] != undefined &&
		const_var.stateNameAcordingAPI[val] != const_var.shippingState
	) {
		delete const_var.post_data.address;
		delete const_var.post_data.shipping_zipcode;
		delete const_var.post_data.full_name;
		delete const_var.post_data.first_name;
		delete const_var.post_data.last_name;
		delete const_var.post_data.phone_no;
		delete const_var.post_data.email;
		const_var.shippingState = "Select";
		const_var.tempPostData = {};
	}

	const_var.discount_info = null;
	const_var.selLoftVal = {
		center: 4,
		left: 4,
		right: 4,
		front: 4,
		back: 4
	};
	return (dispatch) => {
		const_var.showInfoError = true;
		if (val != "Select") {
			dispatch({ type: "stateManufacturerChange", value: val, key: key });
		}
	};
}